import styled from 'styled-components'

export const Timeline = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

export const TimelineItem = styled.li`
  position: relative;
  display: flex;
  padding-left: 32px;
  padding-bottom: 32px;

  &:last-child {
    padding-bottom: 0;
  }

  &:not(:last-child)::before {
    content: '';
    position: absolute;
    left: 11px;
    top: 26px;
    width: 2px;
    height: calc(100% - 24px);
    background-color: var(--highlight);
  }
`

export const Dot = styled.span`
  position: absolute;
  left: 4px;
  top: 6px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: var(--highlight);
`

export const Content = styled.div`
  h3 {
    margin: 0 0 4px;
    color: var(--light);
  }

  p {
    color: var(--main);
  }
`
export const Subtitle = styled.p`
  margin: 0;
`
export const Year = styled.p`
  margin: 0;
  font-size: 86%;
`
export const Description = styled.p`
  margin-top: var(--padding-s);
`
export const Logo = styled.div`
  display: inline-block;
  position: relative;
  width: 28px;
  height: 28px;
  margin-right: 1em;
  float: left;
  img {
    max-width: 100%;
    object-fit: contain;
  }
`
